import { Link } from 'react-router-dom';
import { liveEvents, upcomingEvents } from '@/mocks/home';

export default function LiveEvents() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              热门赛事
            </h2>
            <p className="mt-2 text-sm text-foreground-500">实时赛事直播 · 即时竞猜 · 极速结算</p>
          </div>
          <Link
            to="/category/football"
            className="hidden md:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex items-center gap-2 mb-6">
          <span className="flex items-center gap-1.5 px-3 py-1 bg-red-50 text-red-600 text-xs font-semibold rounded-full">
            <span className="w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse"></span>
            直播中
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {liveEvents.map((event) => (
            <Link
              key={event.id}
              to={`/category/${event.category}`}
              className="group bg-background-50 border border-background-200/80 rounded-lg p-5 hover:border-primary-300 hover:bg-background-100/50 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-center justify-between mb-3">
                <span className="text-xs text-foreground-500 font-medium">{event.league}</span>
                <span className="flex items-center gap-1 text-xs text-red-500 font-semibold">
                  <span className="w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse"></span>
                  {event.time}
                </span>
              </div>
              <div className="flex items-center justify-between gap-3">
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-foreground-800 truncate">{event.homeTeam}</p>
                  <p className="text-sm font-semibold text-foreground-800 truncate mt-1">{event.awayTeam}</p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="text-center">
                    <span className="text-xl font-heading font-bold text-primary-500">{event.homeScore}</span>
                  </div>
                  <span className="text-xs text-foreground-400">VS</span>
                  <div className="text-center">
                    <span className="text-xl font-heading font-bold text-foreground-700">{event.awayScore}</span>
                  </div>
                </div>
              </div>
              <div className="mt-3 pt-3 border-t border-background-200/50 flex items-center justify-between">
                <span className="text-xs text-foreground-400">
                  <i className="ri-eye-line mr-1"></i>
                  {event.viewers ? `${(event.viewers / 10000).toFixed(1)}万` : ''}
                </span>
                <span className="text-xs font-medium text-primary-500 group-hover:text-primary-600 transition-colors">
                  立即竞猜 <i className="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8">
          <div className="flex items-center gap-2 mb-4">
            <span className="flex items-center gap-1.5 px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full">
              <i className="ri-time-line"></i>
              即将开始
            </span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {upcomingEvents.map((event) => (
              <Link
                key={event.id}
                to={`/category/${event.category}`}
                className="group bg-background-50 border border-background-200/70 rounded-lg p-4 hover:border-primary-300 transition-all duration-200 cursor-pointer"
              >
                <div className="flex items-center justify-between mb-2">
                  <span className="text-xs text-foreground-500">{event.league}</span>
                  <span className="text-xs text-accent-600 font-medium">{event.startTime.slice(5)}</span>
                </div>
                <div className="flex items-center justify-between gap-2">
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground-700 truncate">{event.homeTeam}</p>
                    <p className="text-xs text-foreground-500 mt-0.5">VS</p>
                    <p className="text-sm font-medium text-foreground-700 truncate">{event.awayTeam}</p>
                  </div>
                  <i className="ri-notification-3-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-6 text-center md:hidden">
          <Link
            to="/category/football"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500"
          >
            查看全部赛事 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}